export type MessageKey = keyof typeof en;

const en = {
  "banner.title": "Lift · Event registration and attendance",
  "banner.phoneSim": "Phone layout · ?mobile=0 to exit",
  "nav.menu": "Menu",
  "nav.closeMenu": "Close",
  "nav.home": "Home",
  "nav.register": "Register",
  "nav.events": "Events",
  "nav.account": "Account",
  "nav.signIn": "Sign in",
  "nav.signOut": "Sign out",
  "session.signedIn": "Signed in",
  "nav.profile": "Profile",
  "nav.family": "Family",
  "nav.inbox": "Inbox",
  "nav.settings": "Settings",

  "gate.body1":
    "We are Leelanau County's only free after-school and summertime program for 6th through 12th graders.",
  "gate.body2":
    "Leelanau Investing For Teens (LIFT) is a nonprofit based in Leelanau County's four public school districts dedicated to empowering local youth through opportunity and mentorship.",
  "gate.body3":
    "Our afterschool programming takes place Mondays through Fridays for 6th, 7th, and 8th graders at Suttons Bay, Glen Lake, Leland, and Northport Schools until 5:30 pm, and three days a week in the summer months. We partner with area high schools to support 9th through 12th graders throughout the school day and offer bimonthly weekend activities.",
  "gate.registerMeta": "Family account",
  "gate.registerTitle": "Register",
  "gate.registerBody": "Sign in with your family account, then file this year's form.",
  "gate.registerCta": "Sign in to register →",
  "gate.registerBodyReady": "File this year's form for each student on your account.",
  "gate.registerCtaReady": "Fill the form →",
  "gate.familyMeta": "Family",
  "gate.familyTitle": "Sign in",
  "gate.familyBody": "One login for every Lift-age student in your household.",
  "gate.familyCta": "Email and password →",
  "gate.staffMeta": "Staff",
  "gate.staffTitle": "Sign in",
  "gate.staffBody": "School roster, yearly forms, events, and attendance",
  "gate.createAccount": "Create an account",
  "gate.forgot": "Forgot password",

  "register.metaFinish": "Finish your account",
  "register.metaAdd": "Add another student",
  "register.title": "Permission form",
  "register.hintTitle": "Helpful hint",
  "register.hintFirstStudentBefore": "You're signed in as",
  "register.hintFirstStudentAfter":
    "Add your first student in the form below, then submit for this school year.",
  "register.hintAnotherStudent":
    "{name} is already on your account. Add another student below — guardian contact stays the same.",
  "register.currentForm": "Current form",
  "register.opened": "Opened {date}",
  "register.noForm": "Staff have not opened a school-year form.",
  "register.moreQuestions": "A few more questions",
  "register.optional": "(optional)",
  "register.required": "(required)",
  "register.guardianOnFile":
    "Guardian contact from your account — no need to enter it again.",
  "register.guardianIdentityOnFile":
    "Name and email from your account. Add your phone once below — we'll reuse it for every student.",
  "register.guardianPhoneOnce":
    "Mobile number for trips and emergencies.",
  "register.householdOnFile":
    "Guardian and emergency contact match your other students on file.",
  "fill.yes": "Yes",
  "fill.no": "No",
  "fill.select": "Select",
  "register.submit": "Submit form",
  "register.errorSignIn": "Sign in with your family account to file this form.",
  "register.errorOpen": "No school-year form is open yet.",
  "register.errorFields": "Fill in student, guardian, and emergency contact.",
  "register.errorConsents":
    "Permission slips, medical, and conduct must be signed.",
  "register.errorQuestion": "Please answer: {label}",
  "register.sampleFill": "Fill a random student",
  "register.sampleBusy": "Filling the form…",
  "register.sampleNote":
    "Only available in test environments. Walks through the form and stops on review. Submit to add the student to this account.",
  "sample.testOnly": "Test environments only",

  "done.meta": "You're registered",
  "done.title": "Thanks {name} has been added to your family.",
  "done.lede":
    "This year's form is on file for {school}. You do not fill the form again to join a trip.",
  "done.saved": "School-year form saved",
  "done.submitted": "Submitted {date}",
  "done.next": "Next",
  "done.nextBody":
    "Off-campus trips and RSVP events are on this student's page. Daily afterschool is attendance for staff, not a family event list.",
  "done.demo": "For this prototype, sign in with {email} and password {password}.",
  "done.openLanding": "View upcoming events",
  "done.openFamily": "Open family page",
  "done.signIn": "Sign in",
  "done.mailMeta": "Inbox · Lift",
  "done.mailNote":
    "This note goes to {email}. Lift also gets a copy at the staff inbox.",
  "done.notFound": "Registration not found.",
  "done.register": "Register",

  "signin.family": "Family",
  "signin.staff": "Staff",
  "signin.title": "Sign in",
  "signin.lede":
    "Email and password for this prototype. Nothing is sent to a real server.",
  "signin.ledeHosted": "Email and password for your family account.",
  "signin.resetDone": "Password updated. Sign in with the new one.",
  "signin.already": "Already signed in",
  "signin.continue": "Continue",
  "signin.email": "Email",
  "signin.password": "Password",
  "password.show": "Show",
  "password.hide": "Hide",
  "signin.submit": "Sign in",
  "signin.busy": "Signing in...",
  "signin.create": "Create an account",
  "signin.forgot": "Forgot password",
  "signin.switchFamily": "Family sign in",
  "signin.switchStaff": "Staff sign in",
  "signin.demos": "Dev sign-ins",
  "signin.demosHint": "Password is {password}. Pick a row, then sign in.",
  "signin.demosHintHosted":
    "QA database via .env.local. Dev password {password} (run npm run seed:qa-dev once). Pick a row, then sign in.",
  "signin.browseStudents": "Browse all demo students",
  "signin.tagParent": "Parent",
  "signin.tagStudent": "Student",
  "signin.tagStaff": "Staff",

  "signup.meta": "New account",
  "signup.title": "Create a family account",
  "signup.lede":
    "One parent or guardian login. After you create it, add each Lift-age student on this year's form. Cecilia and Nelson can live under the same profile.",
  "signup.given": "First name",
  "signup.family": "Last name",
  "signup.email": "Email",
  "signup.phone": "Mobile phone",
  "signup.password": "Password",
  "signup.confirm": "Confirm password",
  "signup.submit": "Create account",
  "signup.busy": "Creating...",
  "signup.haveAccount": "I already have an account",
  "signup.passwordRule": "At least {count} characters.",
  "signup.confirmTitle": "Check your email",
  "signup.confirmBody":
    "We sent a confirmation link to {email}. Open it to finish creating your family account.",
  "signup.signedInTitle": "You're signed in",
  "signup.signedInBody":
    "Your family account is ready. Add each Lift-age student on this year's form.",
  "signup.continue": "Continue",

  "events.publicMeta": "Upcoming RSVPs",
  "events.publicTitle": "Upcoming events",
  "events.publicLede":
    "Special trips and off-campus days. Fill this year's form once, then sign in to RSVP. Past dates drop off this list.",
  "events.none": "No upcoming events right now",
  "events.noneForStudents": "No upcoming events for your students",
  "events.publicMetaSingle": "Public event",
  "events.capacity": "Capacity",
  "events.registeredCount": "{registered} / {capacity} registered",
  "events.spots": "{count} spots left",
  "events.full": "Full",
  "events.waitlistOpen": "Waitlist open",
  "events.waitlistLine": "{count} on the waitlist",
  "events.waitlistHow":
    "If someone cancels, the first person waiting is registered.",
  "events.alreadyForm": "Already on this year's form?",
  "events.alreadyFormBody":
    "Sign in and RSVP from Upcoming. You should not fill the registration form again for a trip.",
  "events.signInRsvp": "Sign in to RSVP",
  "events.newForm": "New this year? Fill the form",
  "events.publicLedeSignedIn":
    "Special trips and off-campus days. Open an event to RSVP for a student already on this year's form.",
  "events.signedInAs": "You're signed in as {name}.",
  "events.signedInRsvp":
    "Choose a student to RSVP. You should not fill the registration form again for a trip.",
  "events.rsvpFor": "RSVP for {name}",
  "events.addStudent": "Add another student",
  "events.signedInNeedForm":
    "You're signed in. Add a student on this year's form, then you can RSVP.",
  "events.fillForm": "Fill the form",
  "events.signedInStaff":
    "You're signed in as staff. Families RSVP from their own accounts.",
  "events.openStaff": "Open this event",
  "events.notFound": "Event not found.",
  "events.back": "Back to events",
  "events.about": "About this event",

  "student.unknown": "Unknown student.",
  "student.back": "Back",
  "student.landing": "Upcoming",
  "student.backToEvents": "Back to events",
  "student.hi": "Hi, {name}.",
  "student.metaLine": "{school} · Grade {grade} · 2026-2027 school year",
  "student.yourProfile": "Your profile",
  "student.upcoming": "Upcoming events",
  "student.upcomingLede":
    "RSVP trips for your school and age group. Daily afterschool is not listed here.",
  "student.noUpcoming": "No upcoming events for your school and age",
  "student.registered": "Registered",
  "student.waitlisted": "Waitlisted",
  "student.siblings": "Your students",
  "student.switch": "Switch student",

  "family.meta": "Family",
  "family.title": "Your students",
  "family.lede":
    "One account for every Lift-age student in the household. Open a student to RSVP. Events still filter by that student's school and age.",
  "family.add": "Add another student",
  "family.sample": "Add a random student",
  "family.empty": "No students on this account yet",
  "family.emptyBody": "Fill this year's form once for each student.",
  "family.grade": "Grade {grade}",

  "profile.meta": "Persistent profile",
  "profile.lede":
    "Stored in Lift, not re-entered for every event. Medical notes, media release, and the rest of each school-year form are on this page.",
  "profile.school": "School",
  "profile.grade": "Grade",
  "profile.birthday": "Birthday",
  "profile.age": "Age",
  "profile.studentEmail": "Student email",
  "profile.guardian": "Guardian",
  "profile.emergency": "Emergency contact",
  "profile.name": "Name",
  "profile.email": "Email",
  "profile.phone": "Phone",
  "profile.formOnFile": "On file for this school year",
  "profile.formOnFileLine": "{form} · Submitted {date}",
  "profile.submitted": "Submitted {date}",
  "profile.earlier": "Earlier years",
  "profile.medical": "Medical",
  "profile.media": "Media release",
  "profile.permission": "Permission form",
  "profile.extra": "Other form answers",
  "profile.edit": "Edit student",
  "profile.remove": "Remove student",
  "profile.removeTitle": "Remove {name}?",
  "profile.removeBody":
    "This deletes the student, the saved form, and any event registrations.",
  "profile.removeConfirm": "Remove student",
  "profile.removeCancel": "Keep student",
  "profile.removing": "Removing...",
  "profile.removeError": "Could not remove that student.",
  "edit.meta": "Update student",
  "edit.title": "Edit {name}",
  "edit.lede":
    "Save changes on this student and on this year's form. That includes medical notes and media release.",
  "edit.save": "Save changes",
  "edit.saving": "Saving...",
  "edit.back": "Back to profile",
  "edit.loading": "Loading...",
  "edit.error": "Could not save those changes.",
  "edit.noForm": "No school-year form is open. Name, school, and contacts will still be saved.",
  "create.meta": "New student",
  "create.title": "New student",
  "create.lede":
    "Add a student to the roster. This year's form is saved with them. You can remove them, or any other student, from their profile.",
  "create.save": "Add student",
  "create.saving": "Adding...",
  "create.back": "Back to roster",
  "create.error": "Could not add that student.",
  "create.sample": "Fill with a sample student",

  "studentEvents.meta": "Events",
  "studentEvents.title": "Your events",
  "studentEvents.lede":
    "RSVP trips you joined. Daily afterschool does not show up here.",
  "studentEvents.none": "No upcoming RSVPs yet",
  "studentEvents.noneBody":
    "Upcoming trips for {school} are on the Upcoming tab.",
  "studentEvents.past": "Past trips",
  "studentEvents.pastTag": "Past",
  "studentEvents.waitlist": "Waitlist",
  "studentEvents.waitlistNext": "Next in line",
  "studentEvents.waitlistPlace": "Waitlist #{place}",

  "studentEvent.meta": "Event detail",
  "studentEvent.registeringAs": "Registering as",
  "studentEvent.registeredFlash": "You're registered for this trip.",
  "studentEvent.waitlistedFlash": "You're #{place} on the waitlist.",
  "studentEvent.waitlistedNextUp":
    "You're next on the waitlist. If someone cancels, you're registered.",
  "studentEvent.waitlistedMove":
    "People ahead of you move up first. When you reach the front, you're registered.",
  "studentEvent.waitlistExplain":
    "This trip is full. Join the waitlist and you'll take the next open seat, in the order families join.",
  "studentEvent.fullBody": "This trip is full.",
  "studentEvent.leaveWaitlist": "Leave waitlist",
  "studentEvent.mailMeta": "Confirmation recorded",
  "studentEvent.mailNote":
    "This confirmation goes to {email}, and Lift gets a copy at the staff inbox.",
  "studentEvent.answers": "Your answers",
  "studentEvent.thisTrip": "This trip",
  "studentEvent.register": "Register",
  "studentEvent.joinWaitlist": "Join waitlist",
  "studentEvent.full": "Event full",
  "studentEvent.cancel": "Cancel registration",
  "studentEvent.view": "View event",
  "studentEvent.notFound": "Not found.",
  "studentEvent.guardian": "guardian {name}",

  "forgot.meta": "Account",
  "forgot.title": "Forgot password",
  "forgot.lede":
    "Enter the email on your Lift account. This prototype does not send mail. The next screen shows the reset link.",
  "forgot.sent":
    "In production this would land in {email}. Here is the mock message so you can keep walking the flow.",
  "forgot.mailTitle": "Reset your Lift password",
  "forgot.mailTo": "To {email}",
  "forgot.mailBody":
    "Someone asked to reset the password for this account. Choose a new one from the link below. If you did not ask, you can ignore this.",
  "forgot.choose": "Choose a new password",
  "forgot.back": "Back to sign in",
  "forgot.send": "Send reset link",
  "forgot.sending": "Sending...",
  "forgot.email": "Email",

  "reset.meta": "Account",
  "reset.title": "Choose a new password",
  "reset.lede": "Pick a password you will remember for this prototype.",
  "reset.password": "New password",
  "reset.confirm": "Confirm password",
  "reset.submit": "Save password",
  "reset.busy": "Saving...",

  "claim.meta": "Account from the previous system",
  "claim.title": "Confirm your family",
  "claim.lede":
    "This account was created from your previous Lift records. Check your details, say which children are yours, and choose a password you will use from now on. Lift stays closed until you finish.",
  "claim.details": "Your details",
  "claim.detailsHint":
    "We filled these in from your previous records. Change your name or mobile if they are wrong, then confirm.",
  "claim.given": "First name",
  "claim.family": "Last name",
  "claim.email": "Email",
  "claim.emailNote": "You signed in with this email. It cannot be changed here.",
  "claim.phone": "Mobile",
  "claim.confirm": "I confirm this name, email, and mobile number are mine.",
  "claim.kids": "Are these your children?",
  "claim.kidsHint":
    "These students were linked to your email. Add the ones who are yours. Anyone you leave off will not show on your account.",
  "claim.accept": "{name} is my child",
  "claim.decline": "{name} is not my child",
  "claim.password": "New password",
  "claim.passwordHint":
    "The password from your invitation only got you to this page. It will not work again. Enter a new password below. You will use it each time you sign in.",
  "claim.confirmPassword": "Confirm password",
  "claim.submit": "Save and continue",
  "claim.busy": "Saving...",
} as const;

const es: Record<MessageKey, string> = {
  "banner.title": "Lift · Inscripción a eventos y asistencia",
  "banner.phoneSim": "Vista de teléfono · ?mobile=0 para salir",
  "nav.menu": "Menú",
  "nav.closeMenu": "Cerrar",
  "nav.home": "Inicio",
  "nav.register": "Inscribirse",
  "nav.events": "Eventos",
  "nav.account": "Cuenta",
  "nav.signIn": "Iniciar sesión",
  "nav.signOut": "Cerrar sesión",
  "session.signedIn": "Sesión iniciada",
  "nav.profile": "Perfil",
  "nav.family": "Familia",
  "nav.inbox": "Bandeja",
  "nav.settings": "Ajustes",

  "gate.body1":
    "Somos el único programa gratuito extraescolar y de verano del condado de Leelanau para estudiantes de 6.º a 12.º grado.",
  "gate.body2":
    "Leelanau Investing For Teens (LIFT) es una organización sin fines de lucro en los cuatro distritos escolares públicos del condado de Leelanau, dedicada a apoyar a la juventud local con oportunidades y mentoría.",
  "gate.body3":
    "El programa extraescolar es de lunes a viernes para 6.º, 7.º y 8.º grado en Suttons Bay, Glen Lake, Leland y Northport hasta las 5:30 p. m., y tres días a la semana en el verano. Colaboramos con las preparatorias para apoyar a 9.º a 12.º grado durante el día escolar y ofrecemos actividades de fin de semana cada dos meses.",
  "gate.registerMeta": "Cuenta familiar",
  "gate.registerTitle": "Inscribirse",
  "gate.registerBody": "Inicie sesión con su cuenta familiar y luego llene el formulario de este año.",
  "gate.registerCta": "Inicie sesión para inscribirse →",
  "gate.registerBodyReady": "Llene el formulario de este año para cada estudiante de su cuenta.",
  "gate.registerCtaReady": "Llenar el formulario →",
  "gate.familyMeta": "Familia",
  "gate.familyTitle": "Iniciar sesión",
  "gate.familyBody":
    "Un solo acceso para cada estudiante de Lift en su hogar.",
  "gate.familyCta": "Correo y contraseña →",
  "gate.staffMeta": "Personal",
  "gate.staffTitle": "Iniciar sesión",
  "gate.staffBody": "Lista escolar, formularios, eventos y asistencia",
  "gate.createAccount": "Crear una cuenta",
  "gate.forgot": "Olvidé la contraseña",

  "register.metaFinish": "Termine su cuenta",
  "register.metaAdd": "Agregar otro estudiante",
  "register.title": "Formulario de permiso",
  "register.hintTitle": "Consejo útil",
  "register.hintFirstStudentBefore": "Ha iniciado sesión como",
  "register.hintFirstStudentAfter":
    "Agregue su primer estudiante en el formulario de abajo y envíelo para este año escolar.",
  "register.hintAnotherStudent":
    "{name} ya está en su cuenta. Agregue otro estudiante abajo — el contacto del tutor permanece igual.",
  "register.currentForm": "Formulario actual",
  "register.opened": "Abierto {date}",
  "register.noForm": "El personal aún no ha abierto el formulario del año escolar.",
  "register.moreQuestions": "Algunas preguntas más",
  "register.optional": "(opcional)",
  "register.required": "(obligatorio)",
  "register.guardianOnFile":
    "Contacto del tutor de su cuenta — no hace falta volver a ingresarlo.",
  "register.guardianIdentityOnFile":
    "Nombre y correo de su cuenta. Agregue su teléfono una vez abajo — lo reutilizaremos para cada estudiante.",
  "register.guardianPhoneOnce":
    "Número móvil para viajes y emergencias.",
  "register.householdOnFile":
    "El tutor y el contacto de emergencia coinciden con sus otros estudiantes registrados.",
  "fill.yes": "Sí",
  "fill.no": "No",
  "fill.select": "Seleccionar",
  "register.submit": "Enviar formulario",
  "register.errorSignIn": "Inicie sesión con su cuenta familiar para llenar este formulario.",
  "register.errorOpen": "Aún no hay un formulario del año escolar abierto.",
  "register.errorFields":
    "Complete los datos del estudiante, tutor y contacto de emergencia.",
  "register.errorConsents":
    "Debe firmar permisos, autorización médica y código de conducta.",
  "register.errorQuestion": "Por favor responda: {label}",
  "register.sampleFill": "Llenar un estudiante al azar",
  "register.sampleBusy": "Llenando el formulario…",
  "register.sampleNote":
    "Solo disponible en entornos de prueba. Recorre el formulario y se detiene en la revisión. Envíe para agregar el estudiante a esta cuenta.",
  "sample.testOnly": "Solo entornos de prueba",

  "done.meta": "Ya está inscrito",
  "done.title": "Gracias. {name} se agregó a su familia.",
  "done.lede":
    "El formulario de este año está archivado para {school}. No tiene que llenar el formulario otra vez para unirse a un viaje.",
  "done.saved": "Formulario del año escolar guardado",
  "done.submitted": "Enviado {date}",
  "done.next": "Siguiente",
  "done.nextBody":
    "Los viajes y eventos RSVP están en la página de este estudiante. El programa extraescolar diario es asistencia del personal, no una lista familiar.",
  "done.demo":
    "En este prototipo, inicie sesión con {email} y la contraseña {password}.",
  "done.openLanding": "Ver próximos eventos",
  "done.openFamily": "Abrir página familiar",
  "done.signIn": "Iniciar sesión",
  "done.mailMeta": "Bandeja · Lift",
  "done.mailNote":
    "Esta nota va a {email}. Lift también recibe una copia en la bandeja del personal.",
  "done.notFound": "No se encontró la inscripción.",
  "done.register": "Inscribirse",

  "signin.family": "Familia",
  "signin.staff": "Personal",
  "signin.title": "Iniciar sesión",
  "signin.lede":
    "Correo y contraseña para este prototipo. No se envía nada a un servidor real.",
  "signin.ledeHosted": "Correo y contraseña de su cuenta familiar.",
  "signin.resetDone": "Contraseña actualizada. Inicie sesión con la nueva.",
  "signin.already": "Ya tiene la sesión iniciada",
  "signin.continue": "Continuar",
  "signin.email": "Correo",
  "signin.password": "Contraseña",
  "password.show": "Mostrar",
  "password.hide": "Ocultar",
  "signin.submit": "Iniciar sesión",
  "signin.busy": "Entrando...",
  "signin.create": "Crear una cuenta",
  "signin.forgot": "Olvidé la contraseña",
  "signin.switchFamily": "Inicio de sesión familiar",
  "signin.switchStaff": "Inicio de sesión del personal",
  "signin.demos": "Accesos de desarrollo",
  "signin.demosHintHosted":
    "Usa Supabase de su .env local (QA). La contraseña es {password}. Elija una fila e inicie sesión.",
  "signin.demosHint":
    "La contraseña es {password}. Elija una fila y luego inicie sesión.",
  "signin.browseStudents": "Ver todos los estudiantes de demostración",
  "signin.tagParent": "Tutor",
  "signin.tagStudent": "Estudiante",
  "signin.tagStaff": "Personal",

  "signup.meta": "Cuenta nueva",
  "signup.title": "Crear una cuenta familiar",
  "signup.lede":
    "Un acceso para el padre o tutor. Después, agregue a cada estudiante de Lift en el formulario de este año. Cecilia y Nelson pueden vivir bajo el mismo perfil.",
  "signup.given": "Nombre",
  "signup.family": "Apellido",
  "signup.email": "Correo",
  "signup.phone": "Teléfono móvil",
  "signup.password": "Contraseña",
  "signup.confirm": "Confirmar contraseña",
  "signup.submit": "Crear cuenta",
  "signup.busy": "Creando...",
  "signup.haveAccount": "Ya tengo una cuenta",
  "signup.passwordRule": "Al menos {count} caracteres.",
  "signup.confirmTitle": "Revise su correo",
  "signup.confirmBody":
    "Enviamos un enlace de confirmación a {email}. Ábralo para terminar de crear su cuenta familiar.",
  "signup.signedInTitle": "Ya inició sesión",
  "signup.signedInBody":
    "Su cuenta familiar está lista. Agregue a cada estudiante de Lift en el formulario de este año.",
  "signup.continue": "Continuar",

  "events.publicMeta": "RSVP próximos",
  "events.publicTitle": "Próximos eventos",
  "events.publicLede":
    "Viajes especiales y días fuera del campus. Llene el formulario de este año una vez y luego inicie sesión para confirmar. Las fechas pasadas desaparecen de esta lista.",
  "events.none": "No hay eventos próximos ahora",
  "events.noneForStudents": "No hay eventos próximos para sus estudiantes",
  "events.publicMetaSingle": "Evento público",
  "events.capacity": "Cupo",
  "events.registeredCount": "{registered} / {capacity} inscritos",
  "events.spots": "{count} lugares libres",
  "events.full": "Lleno",
  "events.waitlistOpen": "Lista de espera abierta",
  "events.waitlistLine": "{count} en la lista de espera",
  "events.waitlistHow":
    "Si alguien cancela, la primera persona en espera queda inscrita.",
  "events.alreadyForm": "¿Ya llenó el formulario de este año?",
  "events.alreadyFormBody":
    "Inicie sesión y confirme desde Próximos. No debe llenar el formulario otra vez para un viaje.",
  "events.signInRsvp": "Iniciar sesión para confirmar",
  "events.newForm": "¿Nuevo este año? Llene el formulario",
  "events.publicLedeSignedIn":
    "Viajes especiales y días fuera del campus. Abra un evento para confirmar para un estudiante que ya está en el formulario de este año.",
  "events.signedInAs": "Ya inició sesión como {name}.",
  "events.signedInRsvp":
    "Elija un estudiante para confirmar. No debe llenar el formulario otra vez para un viaje.",
  "events.rsvpFor": "Confirmar para {name}",
  "events.addStudent": "Agregar otro estudiante",
  "events.signedInNeedForm":
    "Ya inició sesión. Agregue un estudiante en el formulario de este año y luego podrá confirmar.",
  "events.fillForm": "Llenar el formulario",
  "events.signedInStaff":
    "Ya inició sesión como personal. Las familias confirman desde sus propias cuentas.",
  "events.openStaff": "Abrir este evento",
  "events.notFound": "Evento no encontrado.",
  "events.back": "Volver a eventos",
  "events.about": "Sobre este evento",

  "student.unknown": "Estudiante desconocido.",
  "student.back": "Volver",
  "student.landing": "Próximos",
  "student.backToEvents": "Volver a eventos",
  "student.hi": "Hola, {name}.",
  "student.metaLine": "{school} · Grado {grade} · año escolar 2026-2027",
  "student.yourProfile": "Su perfil",
  "student.upcoming": "Próximos eventos",
  "student.upcomingLede":
    "Viajes RSVP para su escuela y grupo de edad. El extraescolar diario no aparece aquí.",
  "student.noUpcoming": "No hay eventos próximos para su escuela y edad",
  "student.registered": "Inscrito",
  "student.waitlisted": "Lista de espera",
  "student.siblings": "Sus estudiantes",
  "student.switch": "Cambiar estudiante",

  "family.meta": "Familia",
  "family.title": "Sus estudiantes",
  "family.lede":
    "Una cuenta para cada estudiante de Lift en el hogar. Abra un estudiante para confirmar asistencia. Los eventos se filtran por la escuela y edad de ese estudiante.",
  "family.add": "Agregar otro estudiante",
  "family.sample": "Agregar un estudiante al azar",
  "family.empty": "Aún no hay estudiantes en esta cuenta",
  "family.emptyBody": "Llene el formulario de este año una vez por cada estudiante.",
  "family.grade": "Grado {grade}",

  "profile.meta": "Perfil permanente",
  "profile.lede":
    "Guardado en Lift, no se vuelve a ingresar en cada evento. Las notas médicas, la autorización de medios y el resto de cada formulario del año escolar están en esta página.",
  "profile.school": "Escuela",
  "profile.grade": "Grado",
  "profile.birthday": "Cumpleaños",
  "profile.age": "Edad",
  "profile.studentEmail": "Correo del estudiante",
  "profile.guardian": "Tutor",
  "profile.emergency": "Contacto de emergencia",
  "profile.name": "Nombre",
  "profile.email": "Correo",
  "profile.phone": "Teléfono",
  "profile.formOnFile": "Archivado para este año escolar",
  "profile.formOnFileLine": "{form} · Enviado {date}",
  "profile.submitted": "Enviado {date}",
  "profile.earlier": "Años anteriores",
  "profile.medical": "Información médica",
  "profile.media": "Autorización de medios",
  "profile.permission": "Formulario de permiso",
  "profile.extra": "Otras respuestas del formulario",
  "profile.edit": "Editar estudiante",
  "profile.remove": "Eliminar estudiante",
  "profile.removeTitle": "¿Eliminar a {name}?",
  "profile.removeBody":
    "Esto elimina al estudiante, el formulario guardado y cualquier inscripción a eventos.",
  "profile.removeConfirm": "Eliminar estudiante",
  "profile.removeCancel": "Conservar estudiante",
  "profile.removing": "Eliminando...",
  "profile.removeError": "No se pudo eliminar a ese estudiante.",
  "edit.meta": "Actualizar estudiante",
  "edit.title": "Editar a {name}",
  "edit.lede":
    "Los cambios se guardan en el estudiante y en el formulario de este año. Incluye notas médicas y autorización de medios.",
  "edit.save": "Guardar cambios",
  "edit.saving": "Guardando...",
  "edit.back": "Volver al perfil",
  "edit.loading": "Cargando...",
  "edit.error": "No se pudieron guardar los cambios.",
  "edit.noForm":
    "No hay un formulario del año escolar abierto. El nombre, la escuela y los contactos sí se guardarán.",
  "create.meta": "Estudiante nuevo",
  "create.title": "Estudiante nuevo",
  "create.lede":
    "Agregue un estudiante a la lista. El formulario de este año se guarda con esa persona. Puede eliminar a este o a cualquier otro estudiante desde su perfil.",
  "create.save": "Agregar estudiante",
  "create.saving": "Agregando...",
  "create.back": "Volver a la lista",
  "create.error": "No se pudo agregar a ese estudiante.",
  "create.sample": "Llenar con un estudiante de prueba",

  "studentEvents.meta": "Eventos",
  "studentEvents.title": "Sus eventos",
  "studentEvents.lede":
    "Viajes RSVP a los que se unió. El extraescolar diario no aparece aquí.",
  "studentEvents.none": "Aún no hay RSVP próximos",
  "studentEvents.noneBody":
    "Los viajes próximos de {school} están en la pestaña Próximos.",
  "studentEvents.past": "Viajes pasados",
  "studentEvents.pastTag": "Pasado",
  "studentEvents.waitlist": "Lista de espera",
  "studentEvents.waitlistNext": "Siguiente en la lista",
  "studentEvents.waitlistPlace": "Espera #{place}",

  "studentEvent.meta": "Detalle del evento",
  "studentEvent.registeringAs": "Inscribiendo a",
  "studentEvent.registeredFlash": "Ya está inscrito para este viaje.",
  "studentEvent.waitlistedFlash": "Está en el lugar #{place} de la lista de espera.",
  "studentEvent.waitlistedNextUp":
    "Es el siguiente en la lista de espera. Si alguien cancela, quedará inscrito.",
  "studentEvent.waitlistedMove":
    "Quienes están adelante suben primero. Cuando llegue al frente, quedará inscrito.",
  "studentEvent.waitlistExplain":
    "Este viaje está lleno. Únase a la lista de espera y tomará el siguiente lugar, en el orden en que se anotan las familias.",
  "studentEvent.fullBody": "Este viaje está lleno.",
  "studentEvent.leaveWaitlist": "Salir de la lista de espera",
  "studentEvent.mailMeta": "Confirmación registrada",
  "studentEvent.mailNote":
    "Esta confirmación va a {email}, y Lift recibe una copia en la bandeja del personal.",
  "studentEvent.answers": "Sus respuestas",
  "studentEvent.thisTrip": "Este viaje",
  "studentEvent.register": "Inscribirse",
  "studentEvent.joinWaitlist": "Unirse a la lista de espera",
  "studentEvent.full": "Evento lleno",
  "studentEvent.cancel": "Cancelar inscripción",
  "studentEvent.view": "Ver evento",
  "studentEvent.notFound": "No encontrado.",
  "studentEvent.guardian": "tutor {name}",

  "forgot.meta": "Cuenta",
  "forgot.title": "Olvidé la contraseña",
  "forgot.lede":
    "Ingrese el correo de su cuenta Lift. Este prototipo no envía correo. La siguiente pantalla muestra el enlace.",
  "forgot.sent":
    "En producción esto llegaría a {email}. Aquí está el mensaje de prueba para continuar.",
  "forgot.mailTitle": "Restablezca su contraseña de Lift",
  "forgot.mailTo": "Para {email}",
  "forgot.mailBody":
    "Alguien pidió restablecer la contraseña de esta cuenta. Elija una nueva en el enlace de abajo. Si no lo pidió, puede ignorar este mensaje.",
  "forgot.choose": "Elegir una contraseña nueva",
  "forgot.back": "Volver a iniciar sesión",
  "forgot.send": "Enviar enlace",
  "forgot.sending": "Enviando...",
  "forgot.email": "Correo",

  "reset.meta": "Cuenta",
  "reset.title": "Elija una contraseña nueva",
  "reset.lede": "Elija una contraseña que recuerde para este prototipo.",
  "reset.password": "Nueva contraseña",
  "reset.confirm": "Confirmar contraseña",
  "reset.submit": "Guardar contraseña",
  "reset.busy": "Guardando...",

  "claim.meta": "Cuenta del sistema anterior",
  "claim.title": "Confirme su familia",
  "claim.lede":
    "Esta cuenta se creó con sus registros anteriores de Lift. Revise sus datos, indique cuáles estudiantes son suyos y elija una contraseña que usará de ahora en adelante. Lift permanece cerrado hasta que termine.",
  "claim.details": "Sus datos",
  "claim.detailsHint":
    "Los completamos con sus registros anteriores. Corrija su nombre o celular si están mal y luego confirme.",
  "claim.given": "Nombre",
  "claim.family": "Apellido",
  "claim.email": "Correo",
  "claim.emailNote": "Inició sesión con este correo. No se puede cambiar aquí.",
  "claim.phone": "Celular",
  "claim.confirm": "Confirmo que este nombre, correo y celular son míos.",
  "claim.kids": "¿Estos estudiantes son suyos?",
  "claim.kidsHint":
    "Estos estudiantes estaban vinculados a su correo. Agregue los que son suyos. Quienes deje fuera no aparecerán en su cuenta.",
  "claim.accept": "{name} es mi estudiante",
  "claim.decline": "{name} no es mi estudiante",
  "claim.password": "Contraseña nueva",
  "claim.passwordHint":
    "La contraseña de la invitación solo sirvió para llegar a esta página. No volverá a funcionar. Escriba abajo una contraseña nueva. La usará cada vez que inicie sesión.",
  "claim.confirmPassword": "Confirmar contraseña",
  "claim.submit": "Guardar y continuar",
  "claim.busy": "Guardando...",
};

export const messages = { en, es };
